import { transport } from 'config/transport';

export function callApiExportNhanSuReport(congDoanId, academicYear) {
    return transport.get(`/congdoan/${congDoanId}/baocaonhansu/exportexcel`, { params: { academicYear }, responseType: 'blob' });
}
